import { FC, useEffect, useState } from 'react';
import { UserManagementEventLoggingTemplate } from '../../templates';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { fetchFilteredEventLogs } from '../../../store/contextAPI/eventLogging/reducers/event-logging.slice';
import Spinner from '../../atoms/Spinner/Spinner';

interface UserManagementEventLoggingPageProps {}

const UserManagementEventLoggingPage: FC<
  UserManagementEventLoggingPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [actionFilter, setActionFilter] = useState('');
  const [contextTypeFilter, setContextTypeFilter] = useState('');
  const [searchTermFilter, setSearchTermFilter] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const { eventLogs, status } = useSelector(
    (state: RootState) => state.eventLoggingSlice
  );

  useEffect(() => {
    dispatch(
      fetchFilteredEventLogs({
        action: actionFilter,
        contextType: contextTypeFilter,
        search: searchTermFilter,
        fromDate: fromDate,
        toDate: toDate,
      })
    );
  }, [dispatch, actionFilter, contextTypeFilter]);

  if (status === 'loading') {
    return <Spinner />;
  }

  const handleReset = () => {
    setActionFilter('');
    setContextTypeFilter('');
    setSearchTermFilter('');
    setFromDate('');
    setToDate('');
    dispatch(
      fetchFilteredEventLogs({
        action: '',
        contextType: '',
        search: '',
        fromDate: '',
        toDate: '',
      })
    );
  };

  const handleSearch = () => {
    dispatch(
      fetchFilteredEventLogs({
        action: actionFilter,
        contextType: contextTypeFilter,
        search: searchTermFilter,
        fromDate: fromDate,
        toDate: toDate,
      })
    );
  };

  return (
    <UserManagementEventLoggingTemplate
      data={eventLogs || undefined}
      actionFilter={actionFilter}
      contextTypeFilter={contextTypeFilter}
      setActionFilter={setActionFilter}
      setContextTypeFilter={setContextTypeFilter}
      handleReset={handleReset}
      handleSearch={handleSearch}
      searchTerm={searchTermFilter}
      setSearchTerm={setSearchTermFilter}
      fromDate={fromDate}
      setFromDate={setFromDate}
      toDate={toDate}
      setToDate={setToDate}
    />
  );
};

export default UserManagementEventLoggingPage;
